module.exports = __webpack_public_path__ + "static/band-andy-1448e14d96cbdfdde00ff80cdd011c65.jpg";